import FoodSummary from './FoodSummary';

export default FoodSummary;
